<div class="no-results">
  {{text}}
</div>
